export function showToast(message: string, type: "error" | "success" | "warning" | "info") {
  const toast = document.createElement("div");
  toast.className = "toast toast-bottom toast-center";
  toast.innerHTML = `
    <div class="alert alert-${type}">
      <span>${message}</span>
    </div>
  `;
  document.body.appendChild(toast);

  setTimeout(() => {
    toast.remove();
  }, 5000);
}
